<template>
  <span
    :class="[
      $style.loader,
      {
        [$style.loaderDark]: isDark,
        [$style.loaderLight]: !isDark
      }
    ]"
  ></span>
</template>

<script>
export default {
  props: {
    isDark: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style module lang="scss">
.loader {
  position: absolute;
  top: calc(50% - 4px);
  left: calc(50% - 4px);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 1px solid #ffffff;
  background-color: transparent;
  animation: loader 1500ms linear infinite;
  &.loaderDark {
    border: 1px solid #333333;
    animation: loaderDark 1500ms linear infinite;
    &::before,
    &::after {
      border: 1px solid #333333;
    }
    &::before {
      background-color: #333333;
      animation: loaderBeforeDark 1500ms linear infinite;
    }
    &::after {
      animation: loaderAfterDark 1500ms linear infinite;
    }
  }
  &::before,
  &::after {
    content: "";
    display: block;
    position: absolute;
    border-radius: inherit;
    width: inherit;
    height: inherit;
    top: -1px;
    border: 1px solid #ffffff;
  }
  &::before {
    left: -13px;
    background-color: #ffffff;
    animation: loader_before 1500ms linear infinite;
  }
  &::after {
    right: -13px;
    animation: loader_after 1500ms linear infinite;
  }
}

@keyframes loader {
  0% {
    background-color: transparent;
  }
  25% {
    background-color: #fff;
  }
  50% {
    background-color: transparent;
  }
  75% {
    background-color: transparent;
  }
}

@keyframes loader_before {
  0% {
    background-color: #fff;
  }
  25% {
    background-color: transparent;
  }
  50% {
    background-color: transparent;
  }
  72% {
    background-color: transparent;
  }
}

@keyframes loader_after {
  0% {
    background-color: transparent;
  }
  25% {
    background-color: transparent;
  }
  50% {
    background-color: #fff;
  }
  75% {
    background-color: transparent;
  }
}

@keyframes loaderDark {
  0% {
    background-color: transparent;
  }
  25% {
    background-color: #333333;
  }
  50% {
    background-color: transparent;
  }
  75% {
    background-color: transparent;
  }
}

@keyframes loaderBeforeDark {
  0% {
    background-color: #333333;
  }
  25% {
    background-color: transparent;
  }
  50% {
    background-color: transparent;
  }
  72% {
    background-color: transparent;
  }
}

@keyframes loaderAfterDark {
  0% {
    background-color: transparent;
  }
  25% {
    background-color: transparent;
  }
  50% {
    background-color: #333333;
  }
  75% {
    background-color: transparent;
  }
}
</style>
